import React from 'react';

function Privacy() {
  return (
    <div className="container" style={{ maxWidth: 800, paddingTop: 20, paddingBottom: 60 }}>
      <div className="page-header">
        <h1 className="page-title">隐私政策</h1>
        <p className="page-subtitle">最后更新日期：2026年4月10日</p>
      </div>

      <div className="card" style={{ lineHeight: 1.9, fontSize: '0.92rem', color: 'var(--text-secondary)' }}>
        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>一、引言</h3>
        <p style={{ marginBottom: 16 }}>
          RollSleeves.com（以下简称"本平台"）非常重视您的隐私保护。本隐私政策旨在说明我们如何收集、使用、存储和保护您的个人信息。使用本平台即表示您同意本隐私政策的内容。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>二、信息收集</h3>
        <p style={{ marginBottom: 16 }}>
          我们可能收集以下类型的信息：<br /><br />
          <strong>注册信息：</strong>用户名、邮箱地址、密码（加密存储）、显示名称。如您使用 Google 账号登录，我们会获取您的 Google 账号关联邮箱和公开显示名称。<br /><br />
          <strong>候选人资料：</strong>当您选择创建候选人资料时，您主动填写的信息，包括姓名、职位、工作经验、教育背景、技能、联系方式等。这些信息的公开程度由您自行控制。<br /><br />
          <strong>岗位信息：</strong>您发布的岗位标题、公司名称、描述等内容。<br /><br />
          <strong>使用数据：</strong>您在平台上的评论、消息、浏览记录等交互数据。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>三、信息使用</h3>
        <p style={{ marginBottom: 16 }}>
          我们收集的信息将用于以下目的：<br /><br />
          1. 提供和改善平台服务，包括岗位匹配、信息展示等。<br />
          2. 账户管理和身份验证。<br />
          3. 发送与服务相关的通知（如有必要）。<br />
          4. 平台安全维护和防止滥用。<br />
          5. 数据统计分析以改善用户体验（匿名化处理）。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>四、信息共享与披露</h3>
        <p style={{ marginBottom: 16 }}>
          1. 我们不会向第三方出售您的个人信息。<br />
          2. 您选择公开的候选人资料将对其他注册用户可见。<br />
          3. 在以下情况下，我们可能披露您的信息：法律法规要求；保护本平台或用户的合法权益；经您明确同意。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>五、信息安全</h3>
        <p style={{ marginBottom: 16 }}>
          1. 我们采用行业标准的安全措施保护您的个人信息，包括密码加密存储、数据传输加密等。<br />
          2. 尽管我们努力保护您的个人信息安全，但互联网传输不能保证100%安全，请您理解并注意保护自身信息。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>六、您的权利</h3>
        <p style={{ marginBottom: 16 }}>
          您享有以下与个人信息相关的权利：<br /><br />
          1. <strong>查看权：</strong>您可以随时查看和编辑您的个人资料。<br />
          2. <strong>控制权：</strong>您可以选择是否公开候选人资料。<br />
          3. <strong>删除权：</strong>您可以联系我们要求删除您的账户及相关数据。<br />
          4. <strong>更正权：</strong>如发现个人信息有误，您可以随时更正。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>七、Cookie 使用</h3>
        <p style={{ marginBottom: 16 }}>
          本平台使用 localStorage 存储登录凭证（JWT Token），以保持您的登录状态。我们不使用第三方追踪 Cookie。如您使用 Google 登录，Google 可能会设置相关 Cookie，具体请参考 Google 的隐私政策。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>八、未成年人保护</h3>
        <p style={{ marginBottom: 16 }}>
          本平台的服务面向成年人。我们不会故意收集未满18周岁未成年人的个人信息。如我们发现不慎收集了未成年人信息，将尽快予以删除。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>九、隐私政策更新</h3>
        <p style={{ marginBottom: 16 }}>
          我们可能不时更新本隐私政策。更新后的政策将在平台上公布，继续使用本平台即视为您同意更新后的政策。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>十、联系方式</h3>
        <p>
          如对本隐私政策有任何疑问或需要行使您的数据权利，请通过平台"联系我们"页面与我们取得联系。
        </p>
      </div>
    </div>
  );
}

export default Privacy;
